import { useState } from 'react';
import { Check, X } from 'lucide-react';

export default function InlineDatePicker({ onConfirm, onCancel }) {
  const [date, setDate] = useState('');

  const handleConfirm = () => {
    if (date) {
      onConfirm(date);
    }
  };

  return (
    <div className="flex items-center gap-1.5 bg-surface-elevated p-1.5 rounded-lg border border-border">
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        className="py-1 px-2 bg-surface-card border border-border rounded text-xs text-text-primary w-32"
        autoFocus
      />
      <button
        onClick={handleConfirm}
        disabled={!date}
        className="p-1.5 bg-accent text-white rounded-lg border-none cursor-pointer disabled:opacity-50 transition-all"
        title="Confirm"
      >
        <Check size={14} />
      </button>
      <button
        onClick={onCancel}
        className="p-1.5 bg-surface-hover text-text-secondary rounded-lg border-none cursor-pointer hover:bg-surface-card transition-all"
        title="Cancel"
      >
        <X size={14} />
      </button>
    </div>
  );
}
